/*
  Author: Vaishnavi
  Date: 05/12/2019
  Issue No.: PL-2043
  Issue Description: Input fields alignment issue
*/

/*
  Author: Vinod
  Date: 11/03/2020
  Issue No.: PL-2916
  Issue Description: The same calendar need to be implemented.
  search_string: PL_2916
*/
<template>
  <div class="business">
    <div class="top-bar">
      <span @click="goBackToPaygroup">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{heading}}</span>
    </div>
    <toast-message
      :message="errmsg"
      type="error"
      :isToastEnable="toast"
      @close="(val) => toast = val"
    />
    <div class="content-new">
      <section>
        <tl-select
          labelText="name"
          label="Pay Frequency"
          name="frequncy"
          v-model="payFrequency"
          :options="payFrequencyList"
          @change="(val)=>payrollFormData.payFrequency = val.id"
        />
        <div>
          <div class="lable-text margintop-24">First Effective Payroll Date</div>
          <!-- PL_2916 -->
          <date-picker
            class="datepicker margintop-8"
            :initialView="'month'"
            :formatDate="'MMMM-yyyy'"
            :maximumView="'year'"
            :minimumView="'month'"
            v-model="payrollFormData.firstPayroll"
            @datevalue="(val)=>payrollFormData.firstPayroll=val"
            :dates-disabled="{to:new Date(leIncorporationDate), from: new Date(new Date().setDate(new Date().getDate()-1))}"
          />
          <div class="lable-text margintop-24">Attendance Cut Off Cycle</div>
          <div class="row">
            <div class="col-2 padding-l-n">
              <tl-select
                :options="startDateOptions"
                v-model="payrollFormData.attendanceStart"
                @change="changeDate($event)"
                name="cutOff"
              ></tl-select>
            </div>
            <div class="col-2">
              <tl-select
                :options="startDateOptions"
                v-model="payrollFormData.attendanceEnd"
                :disabled="false"
                @change="(val)=>payrollFormData.attendanceEnd = val"
                name="roundOff"
              ></tl-select>
            </div>
          </div>
        </div>
      </section>

    <pop-up-message
      v-if="showSuccessMsg"
      :message="`Paygroup has been successfully added.`"
      btnText="Back To Paygroups"
      @back="backfrompopup()"
    />
    <bottom-action-container class="placeEnd">
      <template slot="end">
        <btn-grp>
          <btn text="Cancel" type="secondary" @click="goBackToPaygroup"></btn>
          <btn :text="btnText" type="primary" @click="save"></btn>
        </btn-grp>
      </template>
    </bottom-action-container>
  </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { SalaryComponentsConstants } from "../../../../../../apis/constants.js";
export default {
  props: {
    payrollCycleData: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    ...mapGetters({
      editMode: "onboard/paygroup/editMode"
    }),
    ...mapState({
      leData: state => state.onboard.legal_entities.data // PL_2916
    }),
    le_id() {
      return this.$store.getters["onboard/legal_entities/legal_entity_ID"](
        this.$route.params.entity_index
      );
    },
    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Save";
      }
    }
  },
  mounted() {
    this.getAllDates();
    // PL_2916
    this.leIncorporationDate = this.leData[
      this.$route.params.entity_index
    ].incorporationDate;
    if (Object.keys(this.payrollCycleData).length) {
      this.setData(this.payrollCycleData);
    } else {
      this.fetchAll();
    }
  },
  activated() {
    this.getAllDates();
    this.fetchAll();
  },
  data() {
    return {
      heading: "Payroll Cycle",
      payFrequencyList: SalaryComponentsConstants.payFrequencyList,
      payrollFormData: {
        payFrequency: "",
        firstPayroll: "",
        attendanceStart: "",
        attendanceEnd: ""
      },
      payFrequency: "",
      startDateOptions: [],
      showSuccessMsg: false,
      errmsg: "",
      toast: false,
      leIncorporationDate: null
    };
  },

  methods: {
    ...mapActions({
      act_fetchAll: "onboard/settings/payroll_cycle/fetchAll"
    }),

    /* function to go back to add pay group page  */
    goBackToPaygroup() {
      this.$emit("payrollcycle");
    },

    /* function to set end date after selecting start date */
    changeDate(event) {
      try {
        this.payrollFormData.attendanceStart = event;
        this.payrollFormData.attendanceStart = this.payrollFormData.attendanceStart.toString();
        this.payrollFormData.attendanceEnd = (event !== 1
          ? event - 1
          : 31
        ).toString();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to generate dates for drop down */
    getAllDates() {
      try {
        for (let i = 1; i <= 31; i++) {
          this.startDateOptions.push(i);
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to set form data */
    setData(Obj) {
      try {
        this.payrollFormData.payFrequency = Obj.payFrequency;
        this.payrollFormData.firstPayroll = Obj.firstPayroll;
        this.payrollFormData.attendanceEnd = Obj.attendanceEnd;
        this.payrollFormData.attendanceStart = Obj.attendanceStart;
        for (var j = 0; j < this.payFrequencyList.length; j++) {
          if (
            this.payrollFormData.payFrequency == this.payFrequencyList[j].id
          ) {
            this.payFrequency = this.payFrequencyList[j].name;
          }
        }
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get payroll cycle data for current legal entity to set as default */
    async fetchAll() {
      try {
        let res = await this.act_fetchAll(this.le_id);
        if (this.le_id == res.data.payload.data.le_id) {
          this.payrollFormData.payFrequency =
            res.data.payload.data.payFrequency;
          this.payrollFormData.firstPayroll =
            res.data.payload.data.firstPayroll;
          this.payrollFormData.attendanceEnd =
            res.data.payload.data.attendanceEnd;
          this.payrollFormData.attendanceStart =
            res.data.payload.data.attendanceStart;
        }
        for (var j = 0; j < this.payFrequencyList.length; j++) {
          if (
            this.payrollFormData.payFrequency == this.payFrequencyList[j].id
          ) {
            this.payFrequency = this.payFrequencyList[j].name;
          }
        }
      } catch (err) {
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to save the form data */
    async performAction() {
      try {
        this.apirequestObj = {
          payFrequency: this.payrollFormData.payFrequency,
          firstPayroll: this.payrollFormData.firstPayroll
            ? this.payrollFormData.firstPayroll
            : null,
          attendanceStart: this.payrollFormData.attendanceStart,
          default: true,
          le_id: this.le_id,
          attendanceEnd: this.payrollFormData.attendanceEnd
        };
        this.$emit("updatePayrollCycle", this.apirequestObj);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to validate the form */
    async save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        }
      });
    },

    /* function to refresh the page */
    refresh() {
      try {
        this.errmsg = "";
        this.toast = false;
        this.payrollFormData.payFrequency = "";
        this.payrollFormData.firstPayroll = "";
        this.paygroupFormData.attendanceStart = "";
        this.paygroupFormData.attendanceEnd = false;
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
.business {
  width: 100%;
  height: 100%;
  margin-bottom: 200px;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}
.content-new {
  margin: 32px 32px;
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717;
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.lable-text {
  width: 158px;
  height: 15px;
  font-size: 12px;
  color: #646464;
}
</style>
